<div class="layoutname">
  <div data-region="{{cid}}-region0" class="region region0"></div>
  <div data-region="{{cid}}-region1" class="region region1"></div>
</div>
